<ng-container *transloco="let t;">
<app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

  <div title>
    <h1>
      <span *ngIf="newMode()">{{ t('common.labels.create_competence') }}</span>
      <span *ngIf="editMode()">{{ t('common.labels.competence') }} <strong>{{ competence.getLang('name', transloco.getActiveLang()) }}</strong></span>
    </h1>
  </div>

  <div details>
    <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

        <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
          <app-competence-new *ngIf="newMode()"></app-competence-new>
          <app-competence-basedata *ngIf="editMode()" [competence]="competence" (setEdit)="setEdit($event)"></app-competence-basedata>
        </p-tabPanel>

    </p-tabView>
  </div>

</app-detail-view>
</ng-container>
